import { render, staticRenderFns } from "./AllPromotionList.vue?vue&type=template&id=80ad96b4&scoped=true&"
import script from "./AllPromotionList.vue?vue&type=script&lang=js&"
export * from "./AllPromotionList.vue?vue&type=script&lang=js&"
import style0 from "./AllPromotionList.vue?vue&type=style&index=0&id=80ad96b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ad96b4",
  null
  
)

export default component.exports